/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type Image, ImageSchema } from './image'
import type { RichText } from './rich-text'
import { type Tracking, TrackingSchema } from './tracking'
import { type CTAVideo, CTAVideoSchema } from './video'

export type ContentMediaApiProps = {
  technicalName?: string
  contentTitle?: string
  contentTitleType?: 'title1' | 'title2' | 'punchline'
  contentText: RichText
  textPosition: 'left' | 'right'
  backgroundColor?: 'white'
  image: Image
  ctaLink?: CTALink
  ctaVideo?: CTAVideo
  tracking?: Tracking
  surtitle?: string
}

export const ContentMediaApiPropsSchema = z.object({
  technicalName: z.string().optional(),
  contentTitle: z.string().optional(),
  contentTitleType: z.enum(['title1', 'title2', 'punchline']).optional(),
  contentText: LooseRichTextSchema,
  textPosition: z.enum(['left', 'right']),
  backgroundColor: z.enum(['white']).optional(),
  image: ImageSchema,
  ctaLink: CTALinkSchema.optional(),
  ctaVideo: CTAVideoSchema.optional(),
  tracking: TrackingSchema.optional(),
  surtitle: z.string().optional(),
})

/* Schemas validation */
type TestContentMediaApiProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<ContentMediaApiProps>,
    z.infer<typeof ContentMediaApiPropsSchema>
  >
>
